module.exports = "/_next/static/images/9c3d432e05b3106e72d0e12e2ce75dae-credit-ric.svg.webp";